// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertConfigOption_container__1ibAk","title":"AlertConfigOption_title__2Vb9o","loader":"AlertConfigOption_loader__22uS3","btn":"AlertConfigOption_btn__1ZUtG"};